import { defineStore } from 'pinia'
import { isUserRole } from '~/composables/utils'
import { UserRole } from '~/types/userRole'
import { useAuthFetch } from '~/composables/useAuthFetch'

export const useStore = defineStore('global', () => {
  const currentTab = ref('personal')
  const currentContent = ref(null)
  const companyCategories = ref([])
  const marketplaceOffers = ref([])
  const cities = ref([])

  async function fetchCities() {
    const { $i18n } = useNuxtApp()
    const headers = new Headers()
    const currentLocale = $i18n.locale.value
    headers.append('Accept-Language', currentLocale)

    const { data } = await useAuthFetch('/companies/cities', {
      method: 'GET',
      headers: headers,
    })
    return data.value
  }
  function fetchCompanyCategories() {
    return new Promise(resolve => {
      useAuthFetch(`/categories`, {
        onResponse({ response }) {
          console.log(response._data)
          companyCategories.value = response._data as Array<Object>
          resolve(0)
        },
      }, true)
    })
  }
  function switchTab(accountType: string) {
    currentTab.value = accountType
  }

  const isCurrentTab = computed(() => {
    return (accountType: string) => {
      return currentTab.value === accountType
    }
  })

  const getCurrentTab = computed(() => {
    currentTab.value
  })

  function setMarketplaceOffers(offers) {
    marketplaceOffers.value = offers
  }
  async function startChat(userId) {
    const { authenticated } = storeToRefs(useAuthStore())
    const { $toast, $socketUtils } = useNuxtApp()
    if (!authenticated.value && !isUserRole.value([UserRole.CLIENT])) {
      $toast.info('Zaloguj się, aby rozpoacząć czat')
      return
    }

    return await $socketUtils.startConversation({ oppositeUserId: userId })
  }
  return {
    fetchCities,
    startChat,
    fetchCompanyCategories,
    switchTab,
    setMarketplaceOffers,
    currentTab,
    marketplaceOffers,
    currentContent,
    companyCategories,
    isCurrentTab,
    getCurrentTab,
    cities
  }
})
